import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Button from './Button';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  showInfo = true,
  totalItems = 0,
  itemsPerPage = 10
}) => {
  if (!totalPages || totalPages <= 1) return null;

  const getVisiblePages = () => {
    // Kalau total halaman sedikit, tampilkan semua
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages = [];
    const delta = 2;
    const left = currentPage - delta;
    const right = currentPage + delta;

    // Selalu tampilkan halaman 1
    pages.push(1);

    // Tambah "..." setelah halaman 1 kalau ada gap
    if (left > 2) {
      pages.push('...');
    }

    // Halaman di sekitar currentPage
    for (let i = Math.max(2, left); i <= Math.min(totalPages - 1, right); i++) {
      pages.push(i);
    }

    // Tambah "..." sebelum halaman terakhir kalau ada gap
    if (right < totalPages - 1) {
      pages.push('...');
    }

    // Selalu tampilkan halaman terakhir
    pages.push(totalPages);

    return pages;
  };

  const visiblePages = getVisiblePages();
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between px-4 py-3 bg-white border-t border-gray-200">
      {showInfo && totalItems > 0 && (
        <div className="flex-1 flex justify-between text-sm text-gray-700 mb-4 sm:mb-0">
          <p>
            Menampilkan <span className="font-medium">{startItem}</span> sampai{' '}
            <span className="font-medium">{endItem}</span> dari{' '}
            <span className="font-medium">{totalItems}</span> hasil
          </p>
        </div>
      )}

      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          leftIcon={<FaChevronLeft size={12} />}
        >
          Previous
        </Button>

        <div className="flex items-center space-x-1">
          {visiblePages.map((page, index) => {
            if (page === '...') {
              return (
                <span key={`dots-${index}`} className="px-3 py-2 text-gray-500 select-none">
                  ...
                </span>
              );
            }

            return (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  page === currentPage
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-700 hover:bg-gray-50 border border-gray-300'
                }`}
              >
                {page}
              </button>
            );
          })}
        </div>

        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          rightIcon={<FaChevronRight size={12} />}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Pagination;